
export default {
    head() {
        return {
            title: `Mentions légales - ${this.$config.siteTitle}`,
            meta: [
                { hid: 'robots', name: 'robots', content: 'noindex' }
            ]
        }
    },
    async asyncData({ $config: { baseApiURL }, $axios }) {
        const props = await $axios.$get(`${baseApiURL}/home/`);
        return {
            featuredCity: props.featuredCity
        }
    }
}
